module.exports = __webpack_public_path__ + "static/media/user-avatar-3.3aff5eed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/console-users/user-avatar-3.svg
// module id = 1469
// module chunks = 0